import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadMeldungHinweis3ListStatus: 'idle',
    loadMeldungHinweis3ListError: undefined as any,
    loadMeldungHinweis3ListLastArgs: undefined as any,
    loadMeldungHinweis3Status: 'idle',
    loadMeldungHinweis3Error: undefined as any,
    saveMeldungHinweis3Status: 'idle',
    saveMeldungHinweis3Error: undefined as any,
    deleteMeldungHinweis3Status: 'idle',
    deleteMeldungHinweis3Error: undefined as any,

    meldungHinweis3List: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadMeldungHinweis3List = createAsyncThunk('meldungHinweis3Slice/loadMeldungHinweis3List', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().meldungHinweis3Slice.loadMeldungHinweis3ListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldhinweis3/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungHinweis3ListStatus } = getState().meldungHinweis3Slice
        return loadMeldungHinweis3ListStatus !== 'pending'
    }
})

export const loadMeldungHinweis3 = createAsyncThunk('meldungHinweis3Slice/loadMeldungHinweis3', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldhinweis3/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungHinweis3Status } = getState().meldungHinweis3Slice
        return loadMeldungHinweis3Status !== 'pending'
    }
})

export const saveMeldungHinweis3 = createAsyncThunk('meldungHinweis3Slice/saveMeldungHinweis3', async ({ meldungHinweis3 }: any, { rejectWithValue }: any) => {
    let promises = []
    if (meldungHinweis3?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurismeldhinweis3/${ meldungHinweis3?.HDR_ID }/`,
            prepareData(meldungHinweis3),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurismeldhinweis3/`,
            prepareData(meldungHinweis3),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveMeldungHinweis3Status } = getState().meldungHinweis3Slice
        return saveMeldungHinweis3Status !== 'pending'
    }
})

export const deleteMeldungHinweis3 = createAsyncThunk('meldungHinweis3Slice/deleteMeldungHinweis3', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurismeldhinweis3/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteMeldungHinweis3Status } = getState().meldungHinweis3Slice
        return deleteMeldungHinweis3Status !== 'pending'
    }
})

const MeldungHinweis3Slice = createSlice({
    name: 'meldungHinweis3Slice',
    initialState,
    reducers: {
        resetloadMeldungHinweis3ListError: (state) => {
            state.loadMeldungHinweis3ListError = undefined
        },
        resetloadMeldungHinweis3: (state) => {
            state.formItem = undefined
            state.loadMeldungHinweis3Error = undefined
        },
        resetloadMeldungHinweis3Error: (state) => {
            state.loadMeldungHinweis3Error = undefined
        },
        resetsaveMeldungHinweis3: (state) => {
            state.formItem = undefined
            state.saveMeldungHinweis3Error = undefined
        },
        resetsaveMeldungHinweis3Error: (state) => {
            state.saveMeldungHinweis3Error = undefined
        },
        resetdeleteMeldungHinweis3Error: (state) => {
            state.deleteMeldungHinweis3Error = undefined
        },
        removeFromMeldungHinweis3ListById: (state, action) => {
            state.meldungHinweis3List = state.meldungHinweis3List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromMeldungHinweis3ListByIds: (state, action) => {
            state.meldungHinweis3List = state.meldungHinweis3List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.meldungHinweis3List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadMeldungHinweis3ListStatus = 'preloaded'
            state.loadMeldungHinweis3ListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.meldungHinweis3List = []
            state.loadMeldungHinweis3ListStatus = 'idle'
            state.loadMeldungHinweis3ListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadMeldungHinweis3List.pending, (state) => {
            state.loadMeldungHinweis3ListStatus = 'pending'
            state.loadMeldungHinweis3ListError = undefined
        })
        builder.addCase(loadMeldungHinweis3List.fulfilled, (state, action) => {
            state.loadMeldungHinweis3ListStatus = 'idle'

            if (!action.payload) { return }

            state.loadMeldungHinweis3ListLastArgs = action.payload.args

            {
                state.meldungHinweis3List = action.payload.data

            }
        })
        builder.addCase(loadMeldungHinweis3List.rejected, (state, action) => {
            state.loadMeldungHinweis3ListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungHinweis3ListError = action.error.message
            } else {
                state.loadMeldungHinweis3ListError = action.payload
            }
        })

        builder.addCase(loadMeldungHinweis3.pending, (state) => {
            state.loadMeldungHinweis3Status = 'pending'
            state.loadMeldungHinweis3Error = undefined
        })
        builder.addCase(loadMeldungHinweis3.fulfilled, (state, action) => {
            state.loadMeldungHinweis3Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungHinweis3List.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungHinweis3List.push(newItem) }
                else { state.meldungHinweis3List[i] = { ...state.meldungHinweis3List[i], ...newItem } }
            }
        })
        builder.addCase(loadMeldungHinweis3.rejected, (state, action) => {
            state.loadMeldungHinweis3Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungHinweis3Error = action.error.message
            } else {
                state.loadMeldungHinweis3Error = action.payload
            }
        })

        builder.addCase(saveMeldungHinweis3.pending, (state) => {
            state.saveMeldungHinweis3Status = 'pending'
            state.saveMeldungHinweis3Error = undefined
        })
        builder.addCase(saveMeldungHinweis3.fulfilled, (state, action) => {
            state.saveMeldungHinweis3Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungHinweis3List.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungHinweis3List.push(newItem) }
                else { state.meldungHinweis3List[i] = { ...state.meldungHinweis3List[i], ...newItem } }
            }
        })
        builder.addCase(saveMeldungHinweis3.rejected, (state, action) => {
            state.saveMeldungHinweis3Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveMeldungHinweis3Error = action.error.message
            } else {
                state.saveMeldungHinweis3Error = action.payload
            }
        })

        builder.addCase(deleteMeldungHinweis3.pending, (state) => {
            state.deleteMeldungHinweis3Status = 'pending'
            state.deleteMeldungHinweis3Error = undefined
        })
        builder.addCase(deleteMeldungHinweis3.fulfilled, (state, action) => {
            state.deleteMeldungHinweis3Status = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.meldungHinweis3List = state.meldungHinweis3List.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.meldungHinweis3List = state.meldungHinweis3List.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteMeldungHinweis3.rejected, (state, action) => {
            state.deleteMeldungHinweis3Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMeldungHinweis3Error = action.error.message
            } else {
                state.deleteMeldungHinweis3Error = action.payload
            }
        })

    }
})

export const {
    resetloadMeldungHinweis3ListError,
    resetloadMeldungHinweis3,
    resetloadMeldungHinweis3Error,
    resetsaveMeldungHinweis3,
    resetsaveMeldungHinweis3Error,
    resetdeleteMeldungHinweis3Error,
    removeFromMeldungHinweis3ListById,
    removeFromMeldungHinweis3ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = MeldungHinweis3Slice.actions
export default MeldungHinweis3Slice.reducer
